import type { PropsWithChildren, ReactNode } from 'react';

import type { CouponType } from '../../../../../schema/coupon/entry.js';
import CouponIndexValidator from './CouponIndexValidator.js';
import { CouponType as CouponTypeComponent } from './CouponType.js';
import ShareCouponUrlConsumer from './ShareCouponUrlConsumer.js';

type CouponTypeServerProps = PropsWithChildren<{
  type: CouponType;
}>;

/**
 * Server component for coupon type.
 * Runs validators and consumers that is dependent on the couponId.
 *
 * @param root0 Component props
 * @param root0.type Coupon type to set in context
 * @param root0.children Component children to render
 * @returns React component children
 */
export function CouponTypeServer({ type, children }: CouponTypeServerProps): ReactNode {
  return (
    <CouponTypeComponent type={type}>
      <CouponIndexValidator />
      <ShareCouponUrlConsumer />
      {children}
    </CouponTypeComponent>
  );
}
